import { Machine } from "xstate";
import ProductsModule from "@/store/modules/productsApps.module";
const viewProductMachine = Machine({
    id: "viewProductMachine",
    context: {
        viewProductId: " ",
    },
    initial: "idle",
    states: {
        idle: {
            always: { target: "gettingProduct" },
        },
        gettingProduct: {
            invoke: {
                id: "gettingProduct",
                src: (context, event) => ProductsModule.GetProductView(context.viewProductId),
                onDone: { target: "loadedProduct" },
                onError: { target: "error" },
            },
        },
        loadedProduct: {
            on: {
                ADD_APP: { target: "addApp" },
                EDIT_APP: { target: "editApp" },
                VIEW_APP: { target: "viewApp" },
            },
        },
        addApp: {
            on: {
                SAVE_APP: { target: "saveApp" },
                CANCEL_APP: { target: "loadedProduct" },
            },
        },
        saveApp: {
            invoke: {
                id: "saveApp",
                src: (context, event) => ProductsModule.UpdateApps(event.payload),
                onDone: { target: "gettingProduct" },
                onError: { target: "addApp" },
            },
        },
        editApp: {
            invoke: {
                id: "editApp",
                src: (context, event) => ProductsModule.GetAppsEditById(event.appsId),
                onDone: { target: "updatingApp" },
                onError: { target: "gettingProduct" },
            },
        },
        updatingApp: {
            on: {
                UPDATE_APP: { target: "editingApp" },
                CANCEL_APP: { target: "loadedProduct" },
            },
        },
        editingApp: {
            invoke: {
                id: "editingApp",
                src: (context, event) => ProductsModule.UpdateApps(event.payload),
                onDone: { target: "gettingProduct" },
                onError: { target: "editApp" },
            },
        },
        viewApp: {
            on: {
                CANCEL_APP: { target: "loadedProduct" },
            },
        },
        error: {
            type: "final",
        },
    },
});
export default viewProductMachine;
